import React from "react";
import { Provider } from "./validation";
import { useFormOrchestrator } from "../../FormContext/useFormContext";
import CustomCardList from "@components/PatientForms/common/CustomCardList";
import { FormField } from "@components/FormEngine/types";
import { CategoryType } from "../../../../types/PatientFormTypes";
import { z } from "zod";

const providerFields: FormField[] = [
  {
    type: "input",
    name: "providerName",
    label: "Provider Name",
    rule: z.string().min(1, "Provider name is required")
  },
  {
    type: "input",
    name: "credentials",
    label: "Credentials",
    rule: z.string()
  },
  {
    type: "input",
    name: "practicingCity",
    label: "Practicing City",
    rule: z.string().min(1, "Practicing city is required")
  },
  {
    type: "date",
    name: "careStartDate",
    label: "Care Start Date",
    fieldProps: {
      formatValue: "MM/DD/YYYY",
      disableFuture: true,
    },
    rule: z.coerce.date().max(new Date(), "Care start date must be in the past")
  },
  {
    type: "date",
    name: "careEndDate",
    label: "Care End Date (if applicable)",
    fieldProps: {
      formatValue: "MM/DD/YYYY",
      disableFuture: true,
    },
    rule: z.coerce.date().max(new Date(), "Care end date must be in the past").nullable()
  }
];

const newProvider: Provider = {
  providerName: "",
  credentials: "",
  practicingCity: "",
  careStartDate: new Date(),
  careEndDate: null,
};

export const ProvidersList: React.FC = () => {
  const { saveCategoryData } = useFormOrchestrator();
  const category: CategoryType = "providerHistory";

  return (
    <CustomCardList
      name="providers"
      label="Providers"
      addButtonText="Provider"
      cardFields={providerFields as any}
      category={category}
      onSaveCategoryData={saveCategoryData}
      newItemTemplate={newProvider}
    />
  );
};

export default ProvidersList; 